import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import environmentalReducer from './environmentalSlice';
import digitalLibraryReducer from './digitalLibrarySlice';

const rootReducer = combineReducers({
  auth: authReducer,
  environmental: environmentalReducer,
  digitalLibrary: digitalLibraryReducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>


